/** CR-111: Intl.RelativeTimeFormat wrapper shared by ThemeCard and
 * ThemeMetadataStrip. Kept in the themes folder because it's specific
 * to the themes UX and doesn't belong in a global utils file. */
export function formatRelative(iso: string | null): string {
  if (!iso) return "Never generated";
  const then = new Date(iso).getTime();
  if (Number.isNaN(then)) return "—";
  const diffSec = Math.round((then - Date.now()) / 1000);
  const abs = Math.abs(diffSec);
  const rtf = new Intl.RelativeTimeFormat("en", { numeric: "auto" });
  if (abs < 60) return rtf.format(diffSec, "second");
  if (abs < 3600) return rtf.format(Math.round(diffSec / 60), "minute");
  if (abs < 86400) return rtf.format(Math.round(diffSec / 3600), "hour");
  return rtf.format(Math.round(diffSec / 86400), "day");
}
